import { Accordion, Image } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const GoalSelection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  min-height: 130px;
  width: 100%;

  ${Accordion?.S?.AccordionBody} {
    margin-top: 0 !important;
  }
`;

const AccordionArea = styled.div`
  display: flex;
  flex: 0.5;
  flex-direction: column;
  max-height: 362px;
  overflow-y: auto;

  button {
    padding: 8px 16px 0 16px;
  }
`;

const MessageArea = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  flex: 0.5;
  max-height: 364px;
  min-height: 70px;
  overflow-y: auto;
  position: fixed;
  right: 10px;
  width: 49%;
`;

const MessageLine = styled.div`
  align-items: center;
  background-color: var(--color-bg-weaker);
  border-bottom: 1px solid var(--color-accent-primary-weaker);
  color: var(--color-fg-default);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  padding: 16px;
  width: 100%;
`;

const AccordionContent = styled.div`
  align-items: flex-start;
  background-color: var(--color-bg-body);
  border-top: 1px solid var(--color-accent-secondary-weaker);
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const AccordionIcon = styled.div`
  display: inline-block;
  height: 32px;
  margin-top: 2px;
  position: relative;
  width: 32px;
`;

const AccordionIconSource = styled(Image)`
  overflow: hidden;
`;

const Library = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  height: 40px;
  justify-content: space-between;
  padding: 0 16px;
  width: 100%;

  ${({ active }) =>
    active &&
    css`
      background-color: var(--color-accent-primary-weakest);
    `}

  &:hover {
    background-color: var(--color-gray-50);
  }
`;

const LibraryName = styled.div``;

const LibraryCount = styled.div``;

const LibraryPlaceholder = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  min-height: 130px;
`;

export {
  AccordionArea,
  AccordionContent,
  AccordionIcon,
  AccordionIconSource,
  GoalSelection,
  Library,
  LibraryCount,
  LibraryName,
  LibraryPlaceholder,
  MessageArea,
  MessageLine
};
